<div class="container-products">
    <p-toast />
    <div>
        <div class="input-group w-100 mx-auto d-flex">
            <input type="search" class="form-control p-3" placeholder="Nombre del producto"
                aria-describedby="search-icon-1"
                (blur)="searchProducts($event)" />
            <span id="search-icon-1" class="input-group-text p-3"><i class="fa fa-search"></i></span>
        </div>
    </div>
    <div class="accordion accordion-flush" id="accordionOrderList">
        <div class="accordion-item" *ngFor="let order of orderList, let ix = index">
            <h2 class="accordion-header">
                <button type="button" class="accordion-button collapsed d-flex flex-column" data-bs-toggle="collapse"
                    [attr.data-bs-target]="'#flush-collapse-'+ix" aria-expanded="false"
                    [attr.aria-controls]="'flush-collapse-'+ix">
                    <div class="order-info-detail">
                        <div class="">
                            <div class="mx-4 px-3">
                                <div>
                                    <span>Orden N°: {{order.order_id}}</span>
                                </div>
                                <div>
                                    <span>Cliente: {{order.userName}}</span>
                                </div>
                            </div>
                            <div class="mx-4 px-3">
                                <span>Proceso: {{order.status}}</span>
                            </div>
                        </div>
                        <div class="mx-4 px-3">
                            <span>Fecha Actualización: {{order.activacion | date:'dd-MM-YYYY'}}</span>
                            <div>
                                <span>C.P.: {{order.cp}}</span>
                            </div>
                            @if ( order.status == 'Enviado' || order.status == 'Entregado' ) {
                                <div>
                                    <span>Guía: {{order.trackingId}}</span>
                                </div>
                            }
                        </div>
                    </div>
                </button>
            </h2>
            <div [id]="'flush-collapse-'+ix" class="accordion-collapse collapse" data-bs-parent="#accordionOrderList">
                <div class="accordion-body">

                    <table class="w-100">
                        <tr>
                            <th class="col-4">Producto</th>
                            <th class="col-2">Cantidad</th>
                            <th class="col-3">Precio Unitario</th>
                            <th class="col-3" *ngIf="showUpdate">Actualización</th>
                            <th class="col-3" *ngIf="!showUpdate"></th>
                        </tr>

                        <tr *ngFor="let detail of order?.details; let j = index">
                            <td class="col-4"> {{detail.product}}</td>
                            <td class="col-2"> {{detail.quantity}}</td>
                            <td class="col-3"> {{detail.unit_price | currency}}</td>
                            <td class="col-3" *ngIf="showUpdate">
                                <input type="text" class="form-control" [(ngModel)]='detail.priceUpdated'
                                    [attr.id]="'price-'+order?.orderId+'-'+j" (blur)="getInfo(detail.priceUpdated, ix, j)" [placeholder]="detail.unit_price" />
                            </td>
                            <td class="col-3" *ngIf="!showUpdate">
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3" class="col-2 col-2 text-center"> <b>Costo de Envío</b></td>
                            <td class="col-2" *ngIf="!showUpdate"> {{order.shippingCost}}</td>
                            <td class="col-3" *ngIf="showUpdate">
                                <input type="text" class="form-control" [(ngModel)]='order.shippingCost'
                                    [attr.id]="'priceShipping'"
                                    (blur)="setShippingCost($event, order)" />
                            </td>
                        </tr>


                    </table>

                </div>
                <div>
                    <div class="btn-position mb-3 mr-3" *ngIf="showOrders === 1 || (showOrders === 4 && order.status == 'Procesando')">
                        <button class="btn btn-primary" (click)="showUpdatePayment(!showUpdate)" *ngIf="!showUpdate">Actualizar Precios</button>
                        <button class="btn btn-primary mx-3" (click)="updateOrder(order)" *ngIf="showUpdate">Aplicar Cambios</button>
                        <button class="btn btn-primary" (click)="showUpdatePayment(!showUpdate)" *ngIf="showUpdate">Cancelar</button>

                        <button class="btn btn-primary mx-3" (click)="showQuotation(order.order_id )" *ngIf="!showUpdate">Ver Cotización</button>
                        <button class="btn btn-primary mx-3" (click)="sendEmailQuotation(order.order_id )" [disabled]="!isValidQuotation" *ngIf="!showUpdate">Enviar Cotización</button>
                         <!-- <a [href]="showQuotation(order.orderId)" download="showQuotation(order.orderId)">
                            aaa
                         </a> -->
                        <!-- <button class="btn btn-success" (click)="updateOrder(order.orderId, detail.sku, detail.priceUpdated)" *ngIf="showUpdate">Guardar Cambios</button> -->
                    </div>
                </div>

                <div>
                    @if ( setTrackingGuide ) {
                        <div>
                            <div class="mt-3 mb-2 d-flex w-100 justify-content-around">
                                <div class="col-4 px-3">
                                    <mat-form-field floatLabel="auto" class="col-xs-6 col-sm-6 col-md-4 col-lg-4">
                                        <mat-label>Número de Guía</mat-label>
                                        <input type="text" class="form-control" [(ngModel)]='order.trackingGuide' placeholder="Ingrese Guía de Seguimiento"
                                            [attr.id]="'trackingGuide-'+order?.orderId" />
                                    </mat-form-field>
                                </div>
                                <div class="col-4 px-3">
                                    <mat-form-field floatLabel="auto" class="col-xs-6 col-sm-6 col-md-4 col-lg-4">
                                        <mat-label>Compañia Transportes</mat-label>
                                        <input type="text" class="form-control" [(ngModel)]='order.trackingCompany' placeholder="Ingrese Compañia de Transporte"
                                            [attr.id]="'trackingCompany-'+order?.orderId" />
                                    </mat-form-field>
                                </div>
                                <div class="col-4 px-3">
                                    <mat-form-field floatLabel="auto" class="col-xs-6 col-sm-6 col-md-4 col-lg-4">
                                        <mat-label>Url Referencia</mat-label>
                                        <input type="text" class="form-control" [(ngModel)]='order.trackingUrl' placeholder="Ingrese Url de Referencia"
                                            [attr.id]="'trackingUrl-'+order?.orderId" />
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    }

                    <div class="btn-position mb-3 mr-3" *ngIf="showOrders === 2 || (showOrders === 4 && order.status == 'Preparando Envío')">
                        
                        @if (!setTrackingGuide ) {
                            <button class="btn btn-primary" (click)="setTrackingGuide=!setTrackingGuide" >Asignar Guía</button>
                        } @else {
                            <button class="btn btn-primary" (click)="setTracking(order.order_id, order);setTrackingGuide=!setTrackingGuide" >Guardar</button>
                            <button class="btn btn-primary mx-3" (click)="setTrackingGuide=!setTrackingGuide" >Cancelar</button>
                        }
                    </div>
                </div>

                <div>
                    <div class="btn-position mb-3 mr-3" *ngIf="showOrders === 3 || (showOrders === 4 && order.status == 'Enviado')">
                            <button class="btn btn-primary" (click)="setDelivered(order.order_id, order.user_id)" >Paquete entregado</button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>